<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('quotation.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('quotation.pageTitle'),
            href: '/quotations'
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-md-6">
            <form>
              <fieldset>
                <legend>{{ $t('quotation.inquiryInfo') }}</legend>
                <inquiry
                  v-model="model"
                  @student-info="student => (studentInfo = student)"
                  :validate="errors"
                />
              </fieldset>
            </form>
          </div>
          <div class="col-md-6">
            <academic
              v-model="model"
              :student-info="studentInfo"
              :validate="errors"
            />
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-md-12">
            <panel :title="$t('quotation.itemList')">
              <item-detail
                v-model="model"
                :student-info="studentInfo"
                :validate="errors"
              />
            </panel>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 text-right">
            <ts-button @click.prevent="$router.push({ name: 'quotation' })">{{
              $t('cancel')
            }}</ts-button>
            <ts-button
              outline
              color="primary"
              class="ml-2 mr-2"
              :waiting="save_add_new_waiting"
              @click.prevent="saveAddNew"
              >{{ $t('save_add_new') }}</ts-button
            >
            <ts-button
              :waiting="save_waiting"
              @click.prevent="save"
              color="primary"
              >{{ $t('save') }}</ts-button
            >
          </div>
        </div>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import Inquiry from './component/inquiry'
import ItemDetail from './component/item-detail'
import Academic from './component/academic'
import moment from 'moment'
import { Errors } from 'form-backend-validation'

export default {
  name: 'quotationCreate',
  components: {
    Inquiry,
    ItemDetail,
    Academic
  },
  data() {
    return {
      model: {
        quot_date: moment().format('DD-MM-YYYY'),
        inquiry_id: '',
        acp_id: '',
        ac_term_id: null,
        grade_id: null,
        study_time: '',
        total_amount: '',
        quot_detail_list: []
      },
      errors: new Errors(),
      save_waiting: false,
      save_add_new_waiting: false,
      studentInfo: null
    }
  },
  created() {},
  methods: {
    save() {
      this.errors = new Errors()
      this.save_waiting = true
      this.$store
        .dispatch('quotation/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.pushBack()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.save_waiting = false
        })
    },
    saveAddNew() {
      this.errors = new Errors()
      this.save_add_new_waiting = true
      this.$store
        .dispatch('quotation/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.clearInput()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.save_add_new_waiting = false
        })
    },
    pushBack() {
      this.$router.push({ name: 'quotation' })
    },
    clearInput() {
      ;(this.model.quot_date = moment().format('DD-MM-YYYY')),
        (this.model.inquiry_id = ''),
        (this.model.acp_id = ''),
        (this.model.ac_term_id = null),
        (this.model.grade_id = null),
        (this.model.study_time = ''),
        (this.model.total_amount = ''),
        (this.model.quot_detail_list = [])
      this.studentInfo = null
    }
  }
}
</script>
